export default "__VITE_ASSET__Vf7UeC5$__"